import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import { DetailsActionProvider } from "@beeldit/core/actions/details/DetailsActionContext";
import TableWithDetailsPage from "@beeldit/core/pages/TableWithDetailsPage";
import TablePage from "@beeldit/core/pages/TablePage";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";

function TherapistsPage() {

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: null,
    filters: null,
    formFilterValues: null,
  }

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
        <EditActionProvider>
            <TablePage
              {...tablePageParams}
            />
        </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default TherapistsPage;
